import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Badge } from '@mantine/core';
import { IconFileReport } from '@tabler/icons-react';
import { hasPublishedReport } from '../../services/reportService';

/**
 * ReportLink
 *
 * Shared button for judging report access. Used in the school students
 * summary table and on the individual "Past Competitions" variation cards.
 *
 * "Ready" = the registration row carries a published `judging_reports` entry
 * (fetch it with a nested select). RLS only returns PUBLISHED reports, so an
 * empty array means "not released yet" and we show the Pending pill.
 *
 * Pass `variationId` to scope readiness to one variation and deep-link to
 * that variation's block on the report page (/report/:id#v-<variationId>).
 */
const ReportLink = ({ registration, variationId, size = 'xs', fullWidth = false }) => {
  const reports = registration?.judging_reports || [];
  const ready = variationId
    ? reports.some((r) => r.variation_id === variationId && r.published_at)
    : hasPublishedReport(registration);

  if (!ready) {
    return (
      <Badge size={size} color="gray" variant="light">
        Pending
      </Badge>
    );
  }

  const to = `/report/${registration.id}${variationId ? `#v-${variationId}` : ''}`;

  return (
    <Button
      component={Link}
      to={to}
      size={size}
      variant="light"
      fullWidth={fullWidth}
      leftSection={<IconFileReport size={14} />}
      style={{ color: 'var(--primary-gold)' }}
    >
      View Report
    </Button>
  );
};

export default ReportLink;
